import { Component } from "react";
import { ColumnConfig, Waffles, wafflesKeyColumnName } from "@app/shared/waffles";
import ProviderAffiliationService from "../providerAffiliationsService";
import { AffiliationType } from "../enumerators";

interface ProviderAffiliationsAccordionProps {
    npi: string;
}

interface ProviderAffiliationsAccordionState {
    records: ProviderAffiliationsTableData[];
}

interface ProviderAffiliationsTableData {
    [wafflesKeyColumnName]: string;
    affiliationType: string;
    name: string;
    type: string;
    providers: number;
    mddoCount: number;
    affiliationStrength: string;
    primary: string;
}

export default class ProviderAffiliationsAccordionResults extends Component<ProviderAffiliationsAccordionProps, ProviderAffiliationsAccordionState> {

    constructor(props: ProviderAffiliationsAccordionProps) {
        super(props);
        this.buildRecords();
    }

    public async componentDidUpdate(prevProps: ProviderAffiliationsAccordionProps) {
        if (prevProps.npi !== this.props.npi) {
            this.buildRecords();
        }
    }

    public render() {
        if (this.state === null) {
            return (<>No provider affiliation results found.</>);
        }

        return <>
            <h6 className="mb-2">Contract Entities (Professional Affiliation)</h6>
            <Waffles<ProviderAffiliationsTableData>
                columns={this.columnConfig}
                data={this.state.records.filter((x) => x.affiliationType === AffiliationType.ProfessionalAffiliation)}
                testId="provider-affiliationprofessional-results"
            />
            <h6 className="mt-4 mb-2">Contract Entities (Institutional Affiliation)</h6>
            <Waffles<ProviderAffiliationsTableData>
                columns={this.columnConfig}
                data={this.state.records.filter((x) => x.affiliationType === AffiliationType.InstitutionalAffiliation)}
                testId="provider-affiliationinstituional-results"
            />
        </>
    }

    private buildRecords = () => {
        const providerAffiliationService = new ProviderAffiliationService();
        providerAffiliationService.GetLatestContractEntitiesByNpi1(this.props.npi).then((data) => {
            const records = data.map((record, index) => ({
                affiliationStrength: `${record.contractEntityAffiliationStrength * 100}%`,
                affiliationType: record.contractEntityAffiliationType,
                key: index.toString(),
                mddoCount: record.contractEntityMdDoCount,
                name: record.contractEntityName,
                primary: record.contractEntityPrimary === true ? 'Primary' : '',
                providers: record.contractEntityProviders,
                type: record.contractEntityType,
            })) as ProviderAffiliationsTableData[];
            this.setState({
                records: records
            })
        });
    }

    private columnConfig: ColumnConfig = {
        /* eslint-disable sort-keys */
        name: {
            displayText: "Name",
            testId: "county",
            sortOrder: 1
        },
        type: {
            displayText: "Type",
            testId: "type",
            sortOrder: 2

        },
        providers: {
            displayText: "Providers",
            testId: "gains-percent",
            sortOrder: 3

        },
        mddoCount: {
            displayText: "MDs/DOs",
            testId: "mddocount",
            sortOrder: 4
        },
        affiliationStrength: {
            displayText: "Affiliation Strength",
            testId: "affiliation-strength",
            sortOrder: 5
        },
        primary: {
            displayText: "",
            testId: "primary",
            sizeContentToFit: true,
            sortOrder: 6,
            noSort: true,
            minWidth: '50px',
        },
        /* eslint-enable */
    }
}